// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Body_wrapper__Tz1Lc","noPadd":"Body_noPadd__5N0Rg"};